"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'access.status.active': 'Activo',
    'access.status.inactive': 'Inactivo',
};
